<template>
  <v-layout style="position: relative">
    <admin-mission-plan ref="editPlan" :uiid="uiid" :enablePayload="missionPlanUiState.enablePayload">
      <div class="flex items-center gap-2 px-2">
        <v-autocomplete
          hide-details
          v-if="isSysAdmin"
          :items="enseignes"
          item-text="ENS_LIBELLE"
          item-value="ENS_ID"
          :label="$t('Admin.MissionPlanTemplate.Form.Company')"
          v-model="ens_id"
          class="pr-2"
        ></v-autocomplete>
        <v-text-field
          class="grow"
          hide-details
          :label="$t('Admin.MissionPlanTemplate.Form.Libelle')"
          v-model="mpt_libelle"
        />
        <!-- <v-switch hide-details v-model="missionPlanUiState.enablePayload" :label="$t('Pilot.MissionPlan.Payload')"></v-switch>           -->
      </div>
    </admin-mission-plan>
  </v-layout>
  <!--

    <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    
    <v-flex xs6 class="inline-block px-4">      
      <v-text-field :label="$t('Admin.MissionPlanTemplate.Form.Surname')" v-model="ens_libelle" />            
    </v-flex>                         
  </v-layout>  

   -->
</template>

<script lang="ts">
import Vue from 'vue'
import { Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import AdminMissionPlan from './AdminMissionPlan.vue'
import { buildMissionPlanStateId, MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
import deepEqual from 'deep-equal'

@Component({
  name: 'AdminMissionPlanTemplateForm',
  components: { AdminMissionPlan },
})
export default class AdminMissionPlanTemplateForm extends Vue {
  get isSysAdmin() {
    return this.$store.myGetters.isSysAdmin
  }

  get missionPlanUiState() {
    return this.$store.myGetters.missionPlanUiStateByUiid(this.uiid)
  }

  created() {
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
  }

  get uiid() {
    return buildMissionPlanStateId(this.modified.MPT_ID || -1, 'template')
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmMissionPlanTemplate
  }

  get curMissionPlanTemplate() {
    return MissionPlanUiState.parseMissionPlan(this.modified.MPT_JSON)
  }

  get enseignes() {
    return this.$store.myGetters.enseignes
  }

  beforeSave() {
    //@ts-ignore
    if (this.$refs.editPlan) this.$refs.editPlan.updateWaypoint()
  }

  @Watch('curMissionPlanTemplate')
  onCurMissionPlanChanged(newValue: any, oldValue: any) {
    this.missionPlanUiState.missionPlan = newValue
    if (!this.missionPlanUiState.payloadAutoSet) {
      this.missionPlanUiState.enablePayload = (newValue?.payload?.length ?? 0) > 0
      this.missionPlanUiState.payloadAutoSet = true
    }
    //@ts-ignore
    if (this.$refs.editPlan && !deepEqual(oldValue, newValue)) this.$refs.editPlan.reset()
  }

  get mpt_libelle() {
    return this.modified.MPT_LIBELLE!
  }
  set mpt_libelle(value: string) {
    this.$store.myActions.MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM({
      MPT_LIBELLE: value,
      //@ts-ignore
      MPT_JSON: JSON.stringify(this.missionPlanUiState.missionPlan),
    })
  }

  get ens_id() {
    return this.modified.ENS_ID!
  }
  set ens_id(value: number) {
    this.$store.myActions.MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM({
      ENS_ID: value,
      //@ts-ignore
      MPT_JSON: JSON.stringify(this.missionPlanUiState.missionPlan),
    })
  }
}
</script>
